import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	editableIndex: -1,
	addNotes: false,
};

const notesReducerSlice = createSlice({
	name: 'notesReducer',
	initialState,
	reducers: {
		setNotesProperties(state, action) {
			return { ...action.payload };
		},
	},
});

export const { setNotesProperties } = notesReducerSlice.actions;
export default notesReducerSlice.reducer;
